


























import {Component, Prop, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";

@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DeleteCategoryDialog extends Vue {
    @Prop() private categoryId!: number;

    get title(): string {
        const category = CategoriesStore.categoryById[this.categoryId] || {};
        const categoryName = category.names["jp"] || "カテゴリー";
        return "【 " + categoryName + " 】を削除してもよろしいですか？"
    }
}
